import React from 'react';
import { HousingRankingsPage } from './pages/HousingRankingsPage';
export function App() {
  return <HousingRankingsPage data-id="element-0" />;
}